'use strict';

var React = require('react');

var AriaMenuButtonManagerContext = React.createContext();

module.exports = AriaMenuButtonManagerContext;